export default class City {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    customerID: 'validString',
    regionID: 'validString',
    id: 'validString',
    name: 'validString',
    province: 'validString',
    createdBy: 'any?',
    updatedBy: 'any?',
    updatedOn: 'any?',
    createdOn: 'any?',
    transactionID: 'any?',
  }
  */
  async createCity(cityObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/city/new';
    req.body = cityObj;
    return await req.exec();
  }
  async updateCity(cityObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = '/city/' + cityObj.id;
    req.body = cityObj;
    return await req.exec();
  }
  async deleteCity(cityID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/city/' + cityID;
    return await req.exec();
  }
  async getCity(cityID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/city/' + cityID;
    return await req.exec();
  }
  async getAllCities() {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/cities/';
    return await req.exec();
  }
}
